import { SoftlineModuleConfig } from '@configs/common';
import { checklisteProviders, checklisteRoutes } from '@softapps/allgemein/checkliste';
import {
  dashboardProviders,
  dashboardRoutes,
  provideKundeninfoWidget,
} from '@softapps/allgemein/dashboard';
import { fibuCoreProviders, kundeninfoLeisteProviders } from '@softapps/fibu/core';
import { freigabeProviders } from '@softapps/fibu/freigabe';
import { haftruecklassProviders } from '@softapps/fibu/haftruecklass';
import { offenePostenProviders } from '@softapps/fibu/offene-posten';
import { artikelvorratProviders, artikelvorratRoutes } from '@softapps/mde/artikelvorrat';
import {
  bestellerfassungProviders,
  bestellerfassungRoutes,
} from '@softapps/mde/bestellerfassung';
import {
  bestellvorschlagProviders,
  bestellvorschlagRoutes,
} from '@softapps/mde/bestellvorschlag';
import {
  etikettendruckProviders,
  etikettendruckRoutes,
} from '@softapps/mde/etikettendruck';
import { retourenProviders, retourenRoutes } from '@softapps/mde/retouren';
import {
  warenverprobungProviders,
  warenverprobungRoutes,
} from '@softapps/mde/warenverprobung';
import { statusabfrageProviders, statusabfrageRoutes } from '@softapps/pms/statusabfrage';
import {
  stempelerfassungProviders,
  stempelerfassungRoutes,
} from '@softapps/pms/stempelerfassung';
import { artikelInfoProviders, artikelInfoRoutes } from '@softapps/wws/artikel-info';
import { wwsCoreProviders } from '@softapps/wws/core';
import {
  BelegDownloadStrategy,
  gesamtabfrageProviders,
  gesamtabfrageRoutes,
  SOFTLINE_CONFIG_GESAMTABFRAGE,
} from '@softapps/wws/gesamtabfrage';
import { kreditlimitProviders } from '@softapps/wws/kreditlimit';
import { kundenabfrageProviders, kundenabfrageRoutes } from '@softapps/wws/kundenabfrage';
import { lieferscheinProviders, lieferscheinRoutes } from '@softapps/wws/lieferschein';
import {
  umsatzstatistikProviders,
  umsatzstatistikRoutes,
} from '@softapps/wws/umsatzstatistik';
import {
  warenuebernahmeProviders,
  warenuebernahmeRoutes,
} from '@softapps/wws/warenuebernahme';
import { provideMdeInventoryModule } from '../../../../../softapps/mde/inventory/src/lib/inventory.providers';
import { mdeInventoryRoutes } from '../../../../../softapps/mde/inventory/src/lib/inventory.routes';
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface HagebauPartnerSoftlineConfig {}

export function provideHagebauPartnerSoftlineModules(
  config?: HagebauPartnerSoftlineConfig
): SoftlineModuleConfig {
  const providers = [
    //Wws
    ...wwsCoreProviders,
    ...fibuCoreProviders,
    ...kundeninfoLeisteProviders,
    ...provideKundeninfoWidget(),
    ...dashboardProviders,

    // Gesamtabfrage (Belege)
    ...gesamtabfrageProviders,

    // Artikel-Info
    ...artikelInfoProviders,

    // MDE Module
    ...artikelvorratProviders,
    ...warenuebernahmeProviders,
    ...bestellvorschlagProviders,
    ...bestellerfassungProviders,
    ...etikettendruckProviders,
    ...provideMdeInventoryModule(),
    ...retourenProviders,
    ...warenverprobungProviders,

    // PMS
    ...statusabfrageProviders,
    ...stempelerfassungProviders,

    ...lieferscheinProviders,
    ...checklisteProviders,

    ...freigabeProviders,
    ...kreditlimitProviders,
    ...umsatzstatistikProviders,
    ...haftruecklassProviders,
    ...offenePostenProviders,
    ...kundenabfrageProviders,

    {
      provide: SOFTLINE_CONFIG_GESAMTABFRAGE,
      useValue: {
        geschaeftsfall: true,
        download: [
          {
            belegart: 'Rechnung',
            strategies: [BelegDownloadStrategy],
          },
          {
            belegart: 'Lieferschein',
            strategies: [BelegDownloadStrategy],
          },
          {
            belegart: 'Auftrag',
            strategies: [BelegDownloadStrategy],
          },
          {
            belegart: 'Offert',
            strategies: [BelegDownloadStrategy],
          },
          {
            belegart: 'Kommissionierschein',
            strategies: [BelegDownloadStrategy],
          },
        ],
      },
    },
  ];

  const routes = {
    public: [],
    internal: [
      ...gesamtabfrageRoutes,
      ...artikelInfoRoutes,
      ...bestellvorschlagRoutes,
      ...bestellerfassungRoutes,
      ...etikettendruckRoutes,
      ...mdeInventoryRoutes,
      ...retourenRoutes,
      ...warenverprobungRoutes,

      ...artikelvorratRoutes,
      ...warenuebernahmeRoutes,

      ...stempelerfassungRoutes,
      ...statusabfrageRoutes,
      ...lieferscheinRoutes,
      ...umsatzstatistikRoutes,
      ...checklisteRoutes,

      ...dashboardRoutes,
      ...kundenabfrageRoutes,
    ],
  };

  return [providers, routes];
}
